import { render, staticRenderFns } from "./TwoLanguageInput.vue?vue&type=template&id=73c07078&scoped=true"
import script from "./TwoLanguageInput.vue?vue&type=script&lang=js"
export * from "./TwoLanguageInput.vue?vue&type=script&lang=js"
import style0 from "./TwoLanguageInput.vue?vue&type=style&index=0&id=73c07078&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c07078",
  null
  
)

export default component.exports